import { render, staticRenderFns } from "./assessmentResult.vue?vue&type=template&id=621aaf68&scoped=true&"
import script from "./assessmentResult.vue?vue&type=script&lang=js&"
export * from "./assessmentResult.vue?vue&type=script&lang=js&"
import style0 from "./assessmentResult.vue?vue&type=style&index=0&id=621aaf68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621aaf68",
  null
  
)

export default component.exports